import { FormGroup, Validators } from '@angular/forms';
import { CustomRegex } from 'app/shared/constants/custom-regex.const';

export class AlertValidationHelper {
  private static isUpdating = false;

  public static updateAlertValidation(form: FormGroup): void {
    if (this.isUpdating) return;
    this.isUpdating = true;

    const productProtection = form.get('productProtection')?.value;
    const arrival = form.get('arrival')?.value;
    const outOfService = form.get('outOfService')?.value;
    const report = form.get('report')?.value;
    const emailControl = form.get('email');
    const phoneNumberControl = form.get('phoneNumber');

    emailControl?.clearValidators();
    phoneNumberControl?.clearValidators();
    phoneNumberControl?.setValidators(
      Validators.pattern(CustomRegex.displayedMobileNumber)
    );
    emailControl?.setValidators(Validators.pattern(CustomRegex.email));

    if (arrival || outOfService || report) {
      emailControl?.setValidators([Validators.required, Validators.email]);
    } else if (productProtection) {
      const emailValue = emailControl?.value;
      const phoneValue = phoneNumberControl?.value;

      if (!emailValue && !phoneValue) {
        // Require both fields initially if empty
        emailControl?.setValidators([
          Validators.required,
          Validators.pattern(CustomRegex.email),
        ]);
        phoneNumberControl?.setValidators([
          Validators.required,
          Validators.pattern(CustomRegex.displayedMobileNumber),
        ]);
      } else if (emailValue) {
        // If email is filled, remove required from phone
        phoneNumberControl?.clearValidators();
        phoneNumberControl?.setValidators(
          Validators.pattern(CustomRegex.displayedMobileNumber)
        );
        emailControl?.setValidators([
          Validators.required,
          Validators.pattern(CustomRegex.email),
        ]);
      } else if (phoneValue) {
        // If phone is filled, remove required from email
        emailControl?.clearValidators();
        emailControl?.setValidators(Validators.pattern(CustomRegex.email));
        phoneNumberControl?.setValidators([
          Validators.required,
          Validators.pattern(CustomRegex.displayedMobileNumber),
        ]);
      }
    }
    emailControl?.updateValueAndValidity();
    phoneNumberControl?.updateValueAndValidity();

    this.isUpdating = false;
  }
}
